import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProjectCategoryProvider } from "./Context/ProjectCategoryContext";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Use StrictMode only in development to avoid double API calls in production
if (process.env.NODE_ENV === 'development') {
  root.render(
    // <React.StrictMode>
        <ProjectCategoryProvider>
          <App />
        </ProjectCategoryProvider>
    // </React.StrictMode>
  );
} else {
  root.render(<App />);
}
//Version 1.0.10 - Optimized for production
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
